export const messages = {
  en: {
    personalInfo: {
      title: 'Personal Center - Personal Information',
      personalCenter: 'Personal Center',
      orderManage: 'Order Management',
      shoppingCart: 'Shopping Cart',
      deliveryAddress: 'Delivery Address',
      personalInfo: 'Personal Information',
      username: 'Username',
      usernamePlaceholder: 'Please input username',
      usernameRequired: 'Username is required',
      phone: 'Phone',
      phonePlaceholder: 'Please input phone number',
      phoneRequired: 'Phone is required',
      phoneFormat: 'Invalid phone format',
      userIdRequired: 'User ID is required',
      saveBtn: 'Save',
      saveSuccess: 'Save successfully',
      saveError: 'Save failed'
    }
  },
  zh: {
    personalInfo: {
      title: '个人中心-个人信息',
      personalCenter: '个人中心',
      orderManage: '订单管理',
      shoppingCart: '购物车',
      deliveryAddress: '收货地址',
      personalInfo: '个人信息',
      username: '用户名',
      usernamePlaceholder: '请输入用户名',
      usernameRequired: '用户名不能为空',
      phone: '手机号',
      phonePlaceholder: '请输入手机号',
      phoneRequired: '手机号不能为空',
      phoneFormat: '手机号格式错误',
      userIdRequired: '用户ID不能为空',
      saveBtn: '保存',
      saveSuccess: '保存成功',
      saveError: '保存失败'
    }
  }
}